/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React from "react";
import { messages } from "../utilities/messages";
import { routes } from "../utilities/routes";
import { validateEmail } from "../utilities/utils";
import LoginForm from "./LoginForm";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      user: { email: "", password: "" },
      loginButtonState: {
        disabled: true,
        text: "Log In",
      },
      passwordType: "password",
    };
    this.processForm = this.processForm.bind(this);
    this.changeUser = this.changeUser.bind(this);
    this.showPassword = this.showPassword.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {
    /* istanbul ignore next */
    if (this.props && this.props.loggeduser && this.props.loggeduser.user_id) {
      this.props.router.push(routes.dashboard_page);
    }
  }

  /* istanbul ignore next */
  componentWillUnmount() {
    /* istanbul ignore next */
    this.props.resetCurrentLoginData();
  }

  /* istanbul ignore next */
  processForm(event) {
    const {
      user: { email, password },
    } = this.state;

    if (event.which && event.which !== 13) {
      return false;
    }
    if (email === "") {
      this.setState({
        errors: {
          summary: messages.auth.error_login_auth,
          email: messages.auth.error_login_auth,
        },
      });
      return false;
    }
    if (email && !validateEmail(email)) {
      this.setState({
        errors: {
          summary: messages.auth.error_login_auth,
          email: messages.auth.error_login_auth,
        },
      });
      return false;
    }
    if (password === "") {
      this.setState({
        errors: {
          summary: messages.auth.error_login_auth,
          password: messages.auth.rror_login_auth,
        },
      });
      return false;
    }
    this.setState({
      loginButtonState: {
        disabled: true,
        text: "Log In",
      },
    });

    this.props.login(email, password);
    return false;
  }

  /* istanbul ignore next */
  changeUser(event) {
    const field = event.target.name;
    const { user } = this.state;
    user[field] = event.target.value;
    if (user.email !== "" && user.password !== "") {
      this.setState({
        loginButtonState: {
          disabled: false,
          text: "Log In",
        },
      });
    } else {
      this.setState({
        loginButtonState: {
          disabled: true,
          text: "Log In",
        },
      });
    }
    this.setState({
      user,
      errors: {
        summary: "",
        email: "",
        password: "",
      },
    });
  }

  showPassword() {
    if (this.state.passwordType === "password") {
      this.setState({
        passwordType: "text",
      });
    } else {
      this.setState({
        passwordType: "password",
      });
    }
  }

  render() {
    let loginPageError;
    const loginButton = this.state.loginButtonState;

    /* istanbul ignore else */
    if (this.state.errors) {
      loginPageError = this.state.errors;
    } else {
      loginPageError = this.state.errors;
    }

    /* istanbul ignore if */
    if (this.props.auth && this.props.auth.error) {
      loginPageError = {
        // summary: this.props.auth.error.message,
        summary: messages.auth.error_login_auth,
      };
      // loginButton = {
      //   disabled: "",
      //   text: "Sign in",
      // }
    }

    return (
      <LoginForm
        onClick={this.processForm}
        onChange={this.changeUser}
        onKeyPress={this.processForm}
        errors={loginPageError}
        user={this.state.user}
        loginButton={loginButton}
        showPassword={this.showPassword}
        auth={this.props.auth}
        passwordType={this.state.passwordType}
      />
    );
  }
}

export default Login;
